export default __webpack_public_path__ + "static/media/kpi.12b28248.svg";